import { Grid, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import DropDown from "../../../../../../../Components/DropDown/DropDown";
import MuiInputField from "../../../../../../../Components/InputField/InputField";
import { TextView } from "../../../../../../../Components/TextView";
import { DetailChip } from "../../../../DetailTab";
import { checkPermission } from "../../../../../../../Utils/Permissions";

export function AddNewTreatment({
  isCancel,
  onClose,
  price,
  setPrice,
  setTreatment,
  treatment,
  share,
  setShare,
  isEditable,
  treatments,
  isInsurance,
  insuranceData,
}) {
  const handleOnChange = (setValue) => (event) => {
    setValue(event.target.value);
  };
  return (
    <Grid container lg={12} marginTop={"30px"}>
      <Grid item lg={3.8}>
        <Typography
          sx={{
            fontWeight: "600",
            fontSize: "14px",
            color: "#4c5a6a",
            paddingBottom: "7px",
            paddingTop: "10px",
          }}>
          Select Treatment
        </Typography>
        {isEditable && checkPermission("KARE_DB_INSURANCE_EDIT") ? (
          <DropDown
            placeHolder={"Select Treatment"}
            viewHeight={"44px"}
            borderRadius={"5px"}
            bgColor="white"
            border="2px solid #e9eff7"
            viewWidth="100%"
            data={treatments}
            value={treatment}
            handleSelected={(e, value) => setTreatment(value)}
          />
        ) : (
          <>
            {insuranceData?.treatmentShareResponses.map((data, index) => (
              <DetailChip
                color={"#effef5"}
                border={"1px solid #65dec7"}
                value={data.treatment.name}
              />
            ))}
          </>
        )}
      </Grid>
      <Grid
        marginX={"30px"}
        container
        lg={3.8}
        justifyContent={"space-between"}>
        <Grid item lg={5.5}>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "14px",
              color: "#4c5a6a",
              paddingBottom: "7px",
              paddingTop: "10px",
            }}>
            {isInsurance ? "Add Average Price" : "Add Price"}
          </Typography>
          {isEditable && checkPermission("KARE_DB_INSURANCE_EDIT") ? (
            <MuiInputField
              type="number"
              onChange={handleOnChange(setPrice)}
              value={price}
              placeHolder={"Add Price"}
            />
          ) : (
            <>
              {insuranceData?.treatmentShareResponses.map((data, index) => (
                <DetailChip
                  color={"#effef5"}
                  border={"1px solid #65dec7"}
                  value={data.price}
                />
              ))}
            </>
          )}
        </Grid>
        <Grid item lg={5.5}>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "14px",
              color: "#4c5a6a",
              paddingBottom: "7px",
              paddingTop: "10px",
            }}>
            Mykare Share
          </Typography>
          {isEditable && checkPermission("KARE_DB_INSURANCE_EDIT") ? (
            <MuiInputField
              type="number"
              onChange={(e) => {
                if (
                  !isNaN(e.target.value) &&
                  e.target.value >= 0 &&
                  e.target.value <= 100
                ) {
                  setShare(e.target.value);
                }
              }}
              value={share}
              placeHolder={"Add Share"}
            />
          ) : (
            <>
              {insuranceData?.treatmentShareResponses.map((data, index) => (
                <DetailChip
                  color={"#effef5"}
                  border={"1px solid #65dec7"}
                  value={data.mykareShare}
                />
              ))}
            </>
          )}
        </Grid>
      </Grid>
      {isCancel && isEditable && (
        <Grid item lg={3.8} container alignItems="center">
          <IconButton onClick={onClose} aria-label="comment">
            <CloseIcon />
          </IconButton>
        </Grid>
      )}
    </Grid>
  );
}

function Ip({
  setMykareShare,
  setHospitalShare,
  hospitalShare,
  mykareShare,
  duplicates,
  setNewValue,
  setDetails,
  isEditable,
  treatments,
}) {
  const handleOnChange = (setValue) => (event) => {
    setValue(event.target.value);
  };

  return (
    <Grid container lg={12} marginTop={"30px"}>
      <Typography fontWeight={600} color="#4c5a6a">
        IP
      </Typography>
      <Grid container lg={12}>
        <Grid item lg={3.8}>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "16px",
              color: "#4c5a6a",
              paddingBottom: "7px",
              paddingTop: "10px",
            }}>
            RMP Hospital %
          </Typography>
          {isEditable ? (
            <MuiInputField
              type="number"
              onChange={(e) => {
                if (
                  !isNaN(e.target.value) &&
                  e.target.value >= 0 &&
                  e.target.value <= 100
                ) {
                  setHospitalShare(e.target.value);
                }
              }}
              value={hospitalShare}
              placeHolder={"Add Hospital Share %"}
            />
          ) : (
            <TextView>{hospitalShare}</TextView>
          )}
        </Grid>
        <Grid item lg={3.8} marginX={"30px"}>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "16px",
              color: "#4c5a6a",
              paddingBottom: "7px",
              paddingTop: "10px",
            }}>
            RMP Mykare %
          </Typography>
          {isEditable ? (
            <MuiInputField
              type="number"
              onChange={(e) => {
                if (
                  !isNaN(e.target.value) &&
                  e.target.value >= 0 &&
                  e.target.value <= 100
                ) {
                  setMykareShare(e.target.value);
                }
              }}
              value={mykareShare}
              placeHolder={"Add Mykare Share %"}
            />
          ) : (
            <TextView>{mykareShare}</TextView>
          )}
        </Grid>
      </Grid>

      {duplicates.map((val, i) => {
        return (
          <AddNewTreatment
            key={i}
            treatments={treatments}
            isEditable={isEditable}
            setPrice={(value) => {
              duplicates[i].price = value;
              setDetails((s) => ({
                ...s,
                hospitalTreatmentShares: duplicates,
              }));
            }}
            price={val.price || ""}
            setTreatment={(value) => {
              duplicates[i].treatment = value;
              setDetails((s) => ({
                ...s,
                hospitalTreatmentShares: duplicates,
              }));
            }}
            treatment={val?.treatment}
            setShare={(value) => {
              duplicates[i].mykareShare = value;
              setDetails((s) => ({
                ...s,
                hospitalTreatmentShares: duplicates,
              }));
            }}
            share={val?.mykareShare || ""}
            onClose={() => {
              const updatedVal = [...duplicates];
              updatedVal.splice(i, 1);
              setNewValue(updatedVal);
            }}
            isCancel={i !== 0}
          />
        );
      })}
    </Grid>
  );
}

export default Ip;
